import { INITIAL_CARD_IMAGES } from '../utils/cards';

type State = {
  playerCards: any;
  bankerCards: any;
  balanceChange: number;
  totalBalance: number;
  totalWinAmount: number;
  minBet: number;
  maxBet: number;
  betAmount: number;
  gamesPlayed: number;
  chosenOutcome: string;
  activeChip: number;
  backgroundFx: boolean;
  chipFx: boolean;
  cardFx: boolean;
  clearFx: boolean;
};

type Action = {
  type: string;
  payload?: any;
  playerCards?: any;
  bankerCards?: any;
};

export const initialState = {
  playerCards: INITIAL_CARD_IMAGES,
  bankerCards: INITIAL_CARD_IMAGES,
  balanceChange: 0,
  totalBalance: 1000,
  totalWinAmount: 0,
  minBet: 10,
  maxBet: 1000,
  betAmount: 0,
  gamesPlayed: 0,
  chosenOutcome: '',
  activeChip: 10,
  backgroundFx: false,
  chipFx: false,
  cardFx: false,
  clearFx: false,
};

export const appReducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'HANDLE_CLEAR_TABLE':
      return {
        ...state,
        playerCards: INITIAL_CARD_IMAGES,
        bankerCards: INITIAL_CARD_IMAGES,
        betAmount: 0,
        chosenOutcome: '',
        activeChip: 10,
        clearFx: true,
        chipFx: false,
        cardFx: false,
      };
    case 'HANDLE_CHIP_CLICK':
      return {
        ...state,
        activeChip: action.payload,
        cardFx: false,
        chipFx: false,
        clearFx: false,
      };
    case 'HANDLE_BET_CLICK':
      return {
        ...state,
        playerCards: action.playerCards,
        bankerCards: action.bankerCards,
        gamesPlayed: state.gamesPlayed + 1,
        totalBalance: state.totalBalance - state.betAmount,
        cardFx: true,
        chipFx: false,
        clearFx: false,
      };
    case 'HANDLE_CHOSEN_OUTCOME':
      return {
        ...state,
        chosenOutcome: action.payload,
        betAmount: state.betAmount + state.activeChip,
        chipFx: true,
        cardFx: false,
        clearFx: false,
      };
    case 'HANDLE_MULTIPLIER':
      return {
        ...state,
        betAmount: state.betAmount * action.payload,
        cardFx: false,
        chipFx: true,
        clearFx: false,
      };
    case 'HANDLE_BACKGROUND_FX':
      return {
        ...state,
        backgroundFx: !state.backgroundFx,
        cardFx: false,
        chipFx: false,
        clearFx: false,
      };
    default:
      return state;
  }
};
